import { DATA_HOOKS } from './Header.constants';
import deprecationTestkitLog from '../../../utils/deprecationTestkitLog';

const headerDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'headerDriverFactory legacy testkit is deprecated and will be removed in next major release. Please use headerUniDriverFactory from Header.uni.driver instead.',
  );

  const title = () =>
    element.querySelector(`[data-hook="${DATA_HOOKS.title}"]`);
  const subtitle = () =>
    element.querySelector(`[data-hook="${DATA_HOOKS.subtitle}"]`);

  return {
    exists: () => !!element,
    title: () => {
      const el = title();
      return el && el.textContent;
    },
    subtitle: () => {
      const el = subtitle();
      return el && el.textContent;
    },
  };
};

export default headerDriverFactory;
